export class NewPassword {
  oldpass: string;
  newpass: string;
  confirmpass: string;
}
